// bootstrap-datepicker ships English only. Load the French and Dutch locales so a
// picker given the page language shows French on FR/BE and Dutch on the Dutch site;
// UK keeps the built-in English (DDT-4450).
require('bootstrap-datepicker');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.fr.js');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.nl.js');
